// extracted by mini-css-extract-plugin
module.exports = {"root":"Footer_root__1QtHj","buttons":"Footer_buttons__30AJD"};